module.exports = __webpack_public_path__ + "img/oculus_before_after_2.daefb90c.png";